import { ViolationClassificationDTO } from "src/models/violation-classification/violation-classification-dto";
import { BaseApiService } from "../base";
import { ViolationClassificationSTO } from "src/models/violation-classification/violation-classification-sto";

export class ViolationClassificationApiService extends BaseApiService<
  ViolationClassificationDTO,
  ViolationClassificationSTO
> {
  constructor() {
    super({
      servicePath: "/ViolationClassification",
      loadItemsPath: "/GetViolationClassifications",
      saveItemsPath: "/SaveViolationClassifications",
    });
  }
}
